/*

👴🛹 Hello fellow engineer! 👴🛹
When adding new features to segway, you should put them behind a feature flag.
This will allow you to toggle them on and off in shipt admin.

Staging - https://staging-admin.shipt.com/feature-flags/segway
Production - https://admin.shipt.com/feature-flags/segway

It's okay if you don't add the new flag in admin right away, the flag values
will default to the values below. If you put something in the list below but not
in admin, the value you put here will be used in staging and production.

If your flag will be in use for a long time it may be beneficial to add a comment about why the flag is in place.

Which list should my flag go in?

`defaultFlags` is what you almost always want. put a flag here unless you have a specific
reason not to.

`defaultFlagsWithParams` is only for flags that actually need per store
targeting in admin (Store / Location / Metro). SNAP/EBT lives here because eligibility
varies by retailer and location. if a new flag requires per store targeting, you should
consider using an Aristotle experiment instead before adding it into here.

 */

export const defaultFlags = {
  add_past_shoppers_as_preferred: false,
  bff_checkout_migration: false,
  bff_loyalty_migration: false,
  // Crew: Innovation — gates the business address type (property type) dropdown
  // on the address form for business personas
  business_address_type: false,
  // Crew: Innovation — when enabled, Circle 360 members are allowed to use Shipt Business
  business_profile_c360: false,
  // Crew: Innovation — gates the phase 1 business profile experience for users
  // who are already members of at least one business group
  business_profile_phase_1: false,
  // Crew: Innovation - gates the business receipt email forwarding UI until the real backend wiring is ready for release
  business_receipt_email_forwarding: false,
  business_spend_analytics: false,
  c360_promo_copy: false,
  cart_transfer: false,
  coupons_search_migration: false,
  delivery_tracker_actionsheet: false,
  gecx_shopping_agent: false,
  graphql_cart_mutations_migration: false,
  more_like_this_migration: false,
  platform_rec_subs: false,
  preferred_shopper_match: false,
  preferred_shopper_refresh: false,
  security_passkey: false,
  // Gates the Shipt Stack / double-delivery experience on web while the feature is rolled out incrementally.
  shipt_stack_double_delivery: false,
  shoppable_videos: false,
  sierra_ai_order_help: false,
  substitution_variations: false,
  transcend_privacy_updates: false,
  usuals_list_broker: false,
}

export const defaultFlagsWithParams = {
  snap_ebt: false,
  snap_ebt_post_order_modification: false,
}
